import { EIR_POSTCODE } from '../../../brands/default/features';

const FIXED_CARD_NUMBER_LENGTH = 16;

const CardFields = {
  cvv: {
    maxlength: 3,
    placeholder: 'security code',
    selector: '#cvv',
  },
  expirationMonth: {
    placeholder: 'exp. month',
    select: {
      options: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
      ],
    },
    selector: '#expiration-month',
  },
  expirationYear: {
    placeholder: 'exp. year',
    select: true,
    selector: '#expiration-year',
  },
  number: {
    maxCardLength: FIXED_CARD_NUMBER_LENGTH,
    placeholder: 'long card number',
    selector: '#card-number',
  },
  postalCode: {
    placeholder: EIR_POSTCODE ? 'eircode' : 'postal code',
    selector: '#postal-code',
  },
};

export default CardFields;
